import React from 'react';
import { ColorProps, WidthProps } from 'styled-system';

import Box from 'components/Box';
import { colors, fontWeights } from 'theme';

export function Placeholder({
  initial,
  width,
  color,
  backgroundColor,
  bg,
  opacity,
}: ColorProps &
  WidthProps & {
    initial: string;
  }) {
  return (
    <Box
      position="relative"
      borderRadius="50%"
      bg={bg || colors.platinum}
      color={color || colors.aluminum}
      backgroundColor={backgroundColor}
      width={width}
      opacity={opacity}
    >
      <Box pb="100%">
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          width="100%"
          height="100%"
          position="absolute"
          top={0}
          left={0}
        >
          <Box
            fontSize={`${typeof width === 'number' ? (40 * width) / 64 : 64}px`}
            fontWeight={fontWeights.bold}
          >
            {initial[0].toUpperCase()}
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
